// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindChannel, TagKindChannel } from "../schema";
import { serialize_KindChannel_internal, deserialize_KindChannel_internal } from "./KindChannel";

export function serialize_TagKindChannel_internal(value: TagKindChannel): unknown {
  return ((value: { discriminator: KindChannel; id: bigint; kind: KindChannel }): unknown => {
    return {
      discriminator: ((value: KindChannel): unknown => {
        return serialize_KindChannel_internal(value);
      })(value["discriminator"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
      kind: ((value: KindChannel): unknown => {
        return serialize_KindChannel_internal(value);
      })(value["kind"]),
    };
  })(value);
}
export function serialize_TagKindChannel(obj: TagKindChannel): string {
  return renderJsonWithNumbersAsBigint(serialize_TagKindChannel_internal(obj));
}
export function deserialize_TagKindChannel_internal(value: unknown): ParserResult<TagKindChannel> {
  return ((
    value: unknown,
  ): ParserResult<{
    discriminator: KindChannel;
    id: bigint;
    kind: KindChannel;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/TagKindChannel]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/TagKindChannel]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "discriminator")) {
      return { success: false, reason: `[#/components/schemas/TagKindChannel/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
    }
    const parsed_discriminator = ((): ParserResult<KindChannel> => {
      return ((value: unknown): ParserResult<KindChannel> => {
        return deserialize_KindChannel_internal(value);
      })(value["discriminator"]);
    })();
    if (!parsed_discriminator.success) {
      return { success: false, reason: parsed_discriminator.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/TagKindChannel/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/TagKindChannel/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/TagKindChannel/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<KindChannel> => {
      return ((value: unknown): ParserResult<KindChannel> => {
        return deserialize_KindChannel_internal(value);
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
  })(value);
}
export function deserialize_TagKindChannel(str: string): ParserResult<TagKindChannel> {
  return deserialize_TagKindChannel_internal(parseJsonWithNumbersAsBigint(str));
}
